export default "__VITE_ASSET__179a5846__"